import { SvgDocAttach } from '~/src/components/svg-components/attach/doc-attach';
import { SvgImgAttach } from '~/src/components/svg-components/attach/img-attach';
import { SvgPdfAttach } from '~/src/components/svg-components/attach/pdf-attach';
import {
    DOC_TYPES_ARRAY,
    IMG_TYPES_ARRAY,
    MB_MULTIPLIER,
    PDF_TYPES_ARRAY,
} from '~/src/components/common-components/dropzone-uploader/dropzone-uploader.constants';

export const getRulesText = (limit: number, labelFormatFiles: string, declOfFiles: string, maxCount: number) => {
    return `Не более ${maxCount} ${declOfFiles}. Максимальный размер файла не более ${limit} Мб.\n` +
            `Формат: ${labelFormatFiles}`;
};

export const getSizeErrorText = (limit: number) => {
    return `Превышен максимальный размер\nприложенных файлов: ${limit} Мб`;
};

export const getFileSizeLimitInBytes = (limit: number) => limit * MB_MULTIPLIER;

export const getFileDataSizeForAttach = (size: number) => {
    if (size < MB_MULTIPLIER) {
        return { size: Number((size / 1024).toFixed(1)), units: 'KB' };
    }
    return { size: Number((size / 1_000_000).toFixed(2)), units: 'MB' };
};

export const getAttachIcon = (type: string) => {
    if (DOC_TYPES_ARRAY.includes(type)) {
        return SvgDocAttach;
    }

    if (IMG_TYPES_ARRAY.includes(type)) {
        return SvgImgAttach;
    }

    if (PDF_TYPES_ARRAY.includes(type)) {
        return SvgPdfAttach;
    }
};